import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import { SessionUtil } from '../util/session.util';
import { MessageService } from 'primeng/components/common/messageservice';
@Injectable()
export class ReservasService extends BaseService<any>{

  private static RESERVA_RESOURCE: string = "/reservas";

  constructor(protected http: Http, protected messageService: MessageService) {
    super(http, messageService);
  }

  public saveReserva(reserva: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    if (reserva.id == null) {
      this.post(BaseService.URL_BASE + ReservasService.RESERVA_RESOURCE, reserva, options, onSuccess);
    } else {
      this.put(BaseService.URL_BASE + ReservasService.RESERVA_RESOURCE, reserva, options, onSuccess);
    }
  }

  public deleteReserva(reserva: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.delete(BaseService.URL_BASE + ReservasService.RESERVA_RESOURCE + "/" + reserva.id, options, onSuccess);
  }

  public getReserva(id: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    this.get(BaseService.URL_BASE + ReservasService.RESERVA_RESOURCE + "/" + id, params, options, onSuccess);
  }

  public getReservas(reservaFilter: any, first: number, max: number, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    if (first != null) {
      params.append("first", first.toString());
    }
    if (max != null) {
      params.append("max", max.toString());
    }
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + ReservasService.RESERVA_RESOURCE, params, options, onSuccess);
  }


  public enviarContacto(contacto: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.post(BaseService.URL_BASE + ReservasService.RESERVA_RESOURCE+"/enviarContacto", contacto, options, onSuccess);
  }

  public enviarReserva(reserva: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.post(BaseService.URL_BASE + ReservasService.RESERVA_RESOURCE+"/enviarReserva", reserva, options, onSuccess);
  }
}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/reservas.service.ts